export const I18n = {
	'en': {
		client: 'Client',
		companyAttributes: 'Company Attributes',
		downloadLink: 'Download client'
	},
	'ru': {
		client: 'Клиент',
		companyAttributes: 'Атрибуты компании',
		downloadLink: 'Скачать клиент'
	},
	'sk': {
		client: 'Zákazník',
		companyAttributes: 'Atribúty Firemné',
		downloadLink: 'Stiahnite si klienta'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/companyClient/index.js